import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    openingPromotion: undefined,
};
const reducers = {
    updateOpeningPromotion: (state, {payload}) => {
        state.openingPromotion = payload;
    }
};

export const PromotionSlice = createSlice(
    {
        name: 'PromotionSlice',
        initialState,
        reducers
    }
);

export default PromotionSlice.reducer;



// WEBPACK FOOTER //
// ./src/app/slices/PromotionSlice.js